export function orderTable(data,column,order){
    let arr = data
    let newArr = [];

    const firstElement = (column) ? arr[0][column] : arr[0];
    const isNumber = !isNaN(firstElement);

    let isAsc = order === -1 ? 'ASC' : 'DESC';

    if(isNumber){
        newArr = arr.sort((a,b) => {
            const x = (column) ? a[column] : a;
            const y = (column) ? b[column] : b;

            if(isAsc === 'ASC'){
                return x - y
            }
            else{
                return y - x
            }
        })
        return newArr
    }
    else{
        newArr = arr.sort((a,b) => {
            const x = (column) ? a[column] : a;
            const y = (column) ? b[column] : b;

            if(isAsc === 'ASC'){
                return x.localeCompare(y)
            }
            else{
                return y.localeCompare(x)
            }
        })
        return newArr
    }
}